<template>
    <div
        v-if="origin"
        style="text-align: center;"
    >
        <i
            class="fa fa-external-link-square"
            style="font-size: 30px; margin: 5px;"
        />
        <i
            class="fa fa-facebook-square"
            style="font-size: 30px; margin: 5px;"
        />
        <i
            class="fa fa-twitter-square"
            style="font-size: 30px; margin: 5px;"
        />
    </div>
    <div
        v-else
        @mousedown="triggerFocus($event, data.id)"
    >
        <table
            style="display: inline-table; vertical-align: top; width: 100%; border-spacing: 0px; border-collapse: collapse;" 
            cellspacing="0" 
            cellpadding="0" 
            border="0"
        >
            <tbody>
                <tr>
                    <td style="width: 100%; text-align: center; font-size: 0;">
                        <div
                            v-if="items.length == 0 || !items[0].type"
                            style="padding: 20px 0; font-size: 14px; color: #000000; text-shadow: 1px 1px 3px #ffffff;"
                        >
                            Добавьте ссылки на соц.сети 
                        </div> 
                        <table
                            ref="contentWrapper"
                            style="display: inline-table; width: 100%;"
                        >
                            <tr>
                                <draggable
                                    v-model="items"
                                    class="social-draggable"
                                    tag="td"
                                    :animation="300"
                                    :handle="'.handle'"
                                    :ghost-class="'.sortable-ghost.social-ghost'"
                                    :group="{name: 'socialLinks'}"
                                    @end="dragEnd"
                                >                                        
                                        <table
                                            v-for="(item, index) in items"
                                            :key="index"
                                            style="display: inline-table;"
                                            :width="Math.floor(100/items.length) + '%'"
                                        >
                                            <tr v-if="item.type">
                                                <td 
                                                    style="width: 60px; height: 100%; text-align: center;"
                                                    :style="{'paddingLeft': data.style ? data.style.paddingLeft: '0px', 'paddingRight': data.style ? data.style.paddingRight : '0px', 'paddingTop': data.style ? data.style.paddingTop: '0px', 'paddingBottom': data.style ? data.style.paddingBottom: '0px'}"
                                                >
                                                    <a 
                                                        style="display: block; position: relative;"
                                                        :href="item.url"
                                                        :class="{'social-hovered': highlightedIcon === index || edit === index}" 
                                                        :data-blockid="data.id+'_'+index"
                                                        @click.prevent=""
                                                    >
                                                        <img
                                                            v-if="item.icon" 
                                                            :src="baseUrl + item.icon.src" 
                                                            :style="{'max-width': item.size + 'px', 'max-height': item.size + 'px'}"
                                                        >
                                                        <img
                                                            v-else
                                                            :src="item.customIcon ? item.customIcon.thumbnail : ''"
                                                            :style="{'max-width': item.size + 'px', 'max-height': item.size + 'px'}"
                                                        >
                                                        <div
                                                            v-if="selected"
                                                            class="social-icon-control"
                                                        >
                                                            <a
                                                                href="#"
                                                                @click.prevent="editItem(index)"
                                                            >
                                                                <span class="fa fa-gear" />
                                                            </a>
                                                            <a class="handle">
                                                                <span class="fa fa-arrows" />
                                                            </a>
                                                            <a
                                                                v-confirm="{
                                                                    okText: 'Да',
                                                                    ok: () => { deleteItem(index) },
                                                                    cancelText: 'Отмена',
                                                                    message: 'Удалить иконку &laquo;'+linkTypes[item.type]+'&raquo;?',
                                                                    backdropClose: false, 
                                                                    animation: 'fade',
                                                                }"
                                                                href="#"
                                                            >
                                                                <span class="fa fa-trash" />
                                                            </a>
                                                        </div>
                                                    </a>
                                                </td>
                                            </tr>
                                        </table>
                                </draggable>
                            </tr>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>

        <block-styles 
            v-if="(isEdited || isForced)" 
            :data="data"
            :wrapper="$refs.contentWrapper"
            @change="updateStyles" 
        />

        <social-dialog
            v-if="edit !== null"
            :lastsize="lastSize"
            :linktypes="linkTypes" 
            :dialogtype="'link'" 
            :item="items[edit]" 
            :index="edit" 
            @close="closeDialog"
            @change="updateData"
        />
    </div>
</template>

<script>
    import BlockStyles from './BlockStyles.vue'
    import ComponentMixin from './Component.vue'
    import SocialMixin from './SocialMixin.vue'
    import SocialDialog from './SocialDialog.vue'
    import draggable from 'vuedraggable';

    export default {
        components: {'social-dialog': SocialDialog, 'block-styles': BlockStyles, 'draggable': draggable},
        mixins: [ComponentMixin, SocialMixin],
        props: {
            'bindedStyles': {
                type: Array,
                default: function () { return [
                    'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom' 
                ] }
            },
        },
        data: function() {
            return {
                linkTypes: {
                    fb: 'facebook',
                    vk: 'вконтакте',
                    ok: 'одноклассники',
                    instagram: 'instagram',
                    twitter: 'twitter',
                    youtube: 'youtube',
                }
            }
        }
    }
</script>
